import { useState } from 'react';

import { RemindPasswordForm } from '../RemindPasswordForm';
import { SuccessScreen } from '@/shared/components/account/signForms/SuccessScreen';

import { RemindPasswordProps } from './types';

export const RemindPassword = ({ backToLoginPress }: RemindPasswordProps) => {
	const [formSent, setFormSent] = useState<string | null>(null);

	return (
		<>
			{formSent ? (
				<SuccessScreen email={formSent} type="remindPassword" backToLoginPress={backToLoginPress} />
			) : (
				<RemindPasswordForm backToLoginPress={backToLoginPress} setFormSent={setFormSent} />
			)}
		</>
	);
};
